import { render, staticRenderFns } from "./warearea.vue?vue&type=template&id=4cf85b12&scoped=true"
import script from "./warearea.vue?vue&type=script&lang=js"
export * from "./warearea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf85b12",
  null
  
)

export default component.exports